import { FC, PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

import { clearAuthorization } from '../../../features/account/reducer/session';
import { GET_STARTED } from '../../../paths';
import { RootState } from '../../../store';

const sessionSelector = (state: RootState) => ({
  verifying: state.session.verifying || state.session.authorized,
  authorized: state.session.authorized,
});

type Props = PropsWithChildren<{
  conditionKey: 'verifying' | 'authorized';
}>;

export const ProtectedRoute: FC<Props> = ({ conditionKey, children }: PropsWithChildren<Props>) => {
  const dispatch = useDispatch();
  const authConditions = useSelector(sessionSelector);
  const isSignedIn = authConditions[conditionKey];
  const { search } = useLocation();

  useEffect(() => {
    if (!isSignedIn) {
      dispatch(clearAuthorization(conditionKey));
    }
  }, [dispatch, isSignedIn, conditionKey]);

  if (!isSignedIn) {
    return <Navigate to={{ pathname: GET_STARTED, search }} replace />;
  }

  return <>{children}</>;
};
